module.exports = __webpack_public_path__ + "img/17.c01face0.svg";